import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { withTranslation } from 'react-i18next';
import { isMobile } from 'react-device-detect';
import Bottom from './Bottom';
import api from '../../api';
import { FormControlLabel, Grid, Radio, RadioGroup } from '@mui/material';
import moment from 'moment';
import PaymentTypeEnum from '../../enums/PaymentTypeEnum';

@inject('commonStore', 'menuStore', 'orderStore')
@observer
class PaymentSmartro extends Component {
  componentDidMount() {
    // 기본 결제 수단 설정
    this.props.orderStore.setPaymentMethod('1');

    // 스마트로페이 SDK 추가
    const script = document.createElement('script');
    script.async = true;
    script.src = `${
      isMobile ? process.env.REACT_APP_SMARTRO_MOBILE_URL : process.env.REACT_APP_SMARTRO_PC_URL
    }/asset/js/SmartroPAY-1.0.min.js?version=${moment(new Date()).format('YYYYMMDD')}`;
    document.body.appendChild(script);
  }

  // 결제방법 변경
  handlePayMethodChange = event => {
    this.props.orderStore.setPaymentMethod(event.target.value);
  };

  pay = async () => {
    const { commonStore, orderStore } = this.props;
    try {
      // 주문 저장
      orderStore.setPaymentType(PaymentTypeEnum.SMARTRO);
      const response = await api.addOrder(orderStore.orderData);

      // 나이스페이 결제 요청 데이터 세팅
      orderStore.setPaymentData(response.data);
    } catch (error) {
      commonStore.setError(error);
      throw error;
    } finally {
      // 결제 버튼 활성화
      orderStore.setDisablePaymentButton(false);
    }

    // 결제 실행
    /* global smartropay */
    smartropay.init({
      mode: process.env.REACT_APP_SMARTRO_PRODUCTION === 'true' ? 'REAL' : 'STG', // STG: 테스트, REAL: 운영(운영서버 전환 시 변경 필수!)
    });

    if (isMobile) {
      smartropay.payment({
        FormId: 'payForm',
      });
    } else {
      smartropay.payment({
        FormId: 'payForm',
        Callback: function (res) {
          var approvalForm = document.approvalForm;
          approvalForm.Tid.value = res.Tid;
          approvalForm.TrAuthKey.value = res.TrAuthKey;
          approvalForm.action = `${process.env.REACT_APP_SMARTORDER_API_URL}/sales/smartro?companyId=${commonStore.companyId}&storeCode=${commonStore.storeCode}&isLiteOrder=${orderStore.isLiteOrder}`;
          approvalForm.submit();
        },
      });
    }
  };

  // goPay() {
  //   const { commonStore, menuStore, orderStore } = this.props;

  //   /* global smartropay */
  //   // 스마트로페이 초기화
  //   smartropay.init({
  //     mode: process.env.REACT_APP_SMARTRO_PRODUCTION === 'true' ? 'REAL' : 'STG', // STG: 테스트, REAL: 운영(운영서버 전환 시 변경 필수!)
  //   });

  //   const returnUrl = `${process.env.REACT_APP_SMARTORDER_API_URL}/sales/smartro?companyId=${commonStore.companyId}&storeCode=${commonStore.storeCode}&isLiteOrder=${orderStore.isLiteOrder}`;

  //   // 스마트로페이 결제요청
  //   smartropay.payment({
  //     PayMethod: 'CARD',
  //     GoodsCnt: '1',
  //     GoodsName: '상품명',
  //     Amt: orderStore.paymentAmount,
  //     Moid: orderStore.paymentData.orderId,
  //     Mid: menuStore.storeData ? menuStore.storeData.merchantID : '',
  //     ReturnUrl: returnUrl,
  //     StopUrl: `${process.env.REACT_APP_SMARTORDER_API_URL}/sales/smartro/cancel?companyId=${commonStore.companyId}&storeCode=${commonStore.storeCode}&isLiteOrder=${orderStore.isLiteOrder}`, // Mobile 연동 시 필수
  //     MallUserId: `${menuStore.storeData.companyId}|${menuStore.storeData.storeCode}`,
  //     BuyerName: '',
  //     BuyerTel: orderStore.orderData.userId,
  //     BuyerEmail: '',
  //     UserIp: '',
  //     MallIp: '',
  //     EdiDate: orderStore.paymentData.ediDate + orderStore.paymentData.ediTime,
  //     Forward: 'Y',
  //     EncryptData: orderStore.paymentData.signData,

  //     // PC 연동의 경우 아래 Callback 함수 구현(Mobile은 제외)
  //     Callback: function (res) {
  //       // 승인 호출
  //       var approvalForm = document.approvalForm;
  //       approvalForm.Tid.value = res.Tid;
  //       approvalForm.TrAuthKey.value = res.TrAuthKey;
  //       approvalForm.action = returnUrl;
  //       approvalForm.submit();
  //     },
  //   });
  // }

  //pc, mobile chack script (sample code)
  checkPlatform(ua) {
    if (ua === undefined) {
      ua = window.navigator.userAgent;
    }

    ua = ua.toLowerCase();
    var platform = {};
    var matched = {};
    var userPlatform = 'pc';
    var platform_match =
      /(ipad)/.exec(ua) ||
      /(ipod)/.exec(ua) ||
      /(windows phone)/.exec(ua) ||
      /(iphone)/.exec(ua) ||
      /(kindle)/.exec(ua) ||
      /(silk)/.exec(ua) ||
      /(android)/.exec(ua) ||
      /(win)/.exec(ua) ||
      /(mac)/.exec(ua) ||
      /(linux)/.exec(ua) ||
      /(cros)/.exec(ua) ||
      /(playbook)/.exec(ua) ||
      /(bb)/.exec(ua) ||
      /(blackberry)/.exec(ua) ||
      [];

    matched.platform = platform_match[0] || '';

    if (matched.platform) {
      platform[matched.platform] = true;
    }

    if (
      platform.android ||
      platform.bb ||
      platform.blackberry ||
      platform.ipad ||
      platform.iphone ||
      platform.ipod ||
      platform.kindle ||
      platform.playbook ||
      platform.silk ||
      platform['windows phone']
    ) {
      userPlatform = 'mobile';
    }

    if (platform.cros || platform.mac || platform.linux || platform.win) {
      userPlatform = 'pc';
    }

    return userPlatform;
  }

  render() {
    const { t, commonStore, menuStore, orderStore } = this.props;
    const returnUrl = `${process.env.REACT_APP_SMARTORDER_API_URL}/sales/smartro?companyId=${commonStore.companyId}&storeCode=${commonStore.storeCode}&isLiteOrder=${orderStore.isLiteOrder}`;
    const cancelUrl = `${process.env.REACT_APP_SMARTORDER_API_URL}/sales/smartro/cancel?companyId=${commonStore.companyId}&storeCode=${commonStore.storeCode}&isLiteOrder=${orderStore.isLiteOrder}`;
    return (
      <React.Fragment>
        {/* 결제방법 선택 */}
        {menuStore.storeData.isEzwelPayUsed && (
          <Grid item container direction={'column'} spacing={1} style={{ marginTop: '25px' }}>
            <Grid item>
              <span style={{ fontSize: '13pt', fontWeight: 'bold' }}>{t('payment.label.method')}</span>
            </Grid>
            <Grid item>
              <RadioGroup
                aria-label="gender"
                name="gender1"
                value={orderStore.paymentMethod}
                onChange={this.handlePayMethodChange}
              >
                <FormControlLabel value={1} control={<Radio color="primary" />} label={'일반결제'} />
                <FormControlLabel value={0} control={<Radio color="primary" />} label={'이지웰페이'} />
              </RadioGroup>
            </Grid>
          </Grid>
        )}

        <form id="payForm" name="payForm" method="post">
          <input type="hidden" name="PayMethod" value="CARD" />
          <input type="hidden" name="GoodsCnt" value={orderStore.paymentCount} />
          <input type="hidden" name="GoodsName" value={orderStore.paymentMenuName} />
          <input type="hidden" name="Amt" value={orderStore.paymentAmount} />
          <input type="hidden" name="Moid" value={orderStore.paymentData.orderId} />
          <input type="hidden" name="Mid" value={menuStore.storeData ? menuStore.storeData.merchantID : ''} />
          <input type="hidden" name="ReturnUrl" value={returnUrl} />
          <input type="hidden" name="StopUrl" value={cancelUrl} />
          <input type="hidden" name="BuyerName" value="" />
          <input type="hidden" name="BuyerTel" value={orderStore.orderData.userId} />
          <input type="hidden" name="BuyerEmail" value="" />
          <input type="hidden" name="EncryptData" value={orderStore.paymentData.signData} />
          <input type="hidden" name="GoodsCl" value="1" />
          <input type="hidden" name="EdiDate" value={orderStore.paymentData.ediDate + orderStore.paymentData.ediTime} />
          <input type="hidden" name="TaxAmt" value={orderStore.orderData.paymentTaxable} />
          <input type="hidden" name="TaxFreeAmt" value={orderStore.orderData.paymentTaxFree} />
          <input type="hidden" name="VatAmt" value={orderStore.orderData.paymentTax} />

          <input type="hidden" name="MallUserId" value={orderStore.orderData.userId} />
          <input
            type="hidden"
            name="MallReserved"
            value={btoa(`${commonStore.companyId}|${commonStore.storeCode}|${orderStore.isLiteOrder}`)}
          />
        </form>

        <form name="approvalForm" method="post" action={returnUrl}>
          <input type="hidden" id="Tid" name="Tid" />
          <input type="hidden" id="TrAuthKey" name="TrAuthKey" />
        </form>

        <Bottom pay={this.pay} />
      </React.Fragment>
    );
  }
}

export default withTranslation()(PaymentSmartro);
